module.exports = __webpack_public_path__ + "static/media/register-bg.5ba87d1a.jpg";